var storageMap = new Map();
function findStorageOnWindow(type) {
    try {
        var storage = window[type];
        if (!storage) {
            return undefined;
        }
        var randomKey = "".concat(Math.round(Math.random() * 1e6));
        storage.setItem(randomKey, randomKey);
        storage.removeItem(randomKey);
        return storage;
    }
    catch (_a) {
        return undefined;
    }
}
export function getStorage(type) {
    if (!storageMap.has(type)) {
        storageMap.set(type, findStorageOnWindow(type));
    }
    return storageMap.get(type);
}
//# sourceMappingURL=getStorage.js.map